import { QYourBet } from "./QYourBet";
export const QueryBuilder = {
    yourBet: QYourBet
};
//# sourceMappingURL=index.js.map